'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _require = require('./contants'),
    CHILD_COMBINATOR_VALUE = _require.CHILD_COMBINATOR_VALUE,
    DESCENDANT_COMBINATOR_VALUE = _require.DESCENDANT_COMBINATOR_VALUE,
    ELEMENT_TOKEN = _require.ELEMENT_TOKEN,
    COMBINATOR_TOKEN = _require.COMBINATOR_TOKEN,
    SELECTOR_SEQUENCE = _require.SELECTOR_SEQUENCE,
    SELECTOR_EXPRESSION_ROOT = _require.SELECTOR_EXPRESSION_ROOT,
    SELECTOR_EXPRESSION_CHILD = _require.SELECTOR_EXPRESSION_CHILD,
    SELECTOR_EXPRESSION_DESCENDANT = _require.SELECTOR_EXPRESSION_DESCENDANT,
    ELEMENT_LITERAL = _require.ELEMENT_LITERAL,
    COMBINATOR_LITERAL = _require.COMBINATOR_LITERAL;

function createSelectorSequence(selectors) {
  return {
    type: SELECTOR_SEQUENCE,
    selectors: selectors
  };
}

function createSelectorExpression(origin, combinator, target) {
  var type = void 0;
  if (!origin && !combinator && target) {
    type = SELECTOR_EXPRESSION_ROOT;
  } else if (combinator.value === CHILD_COMBINATOR_VALUE) {
    type = SELECTOR_EXPRESSION_CHILD;
  } else if (combinator.value === DESCENDANT_COMBINATOR_VALUE) {
    type = SELECTOR_EXPRESSION_DESCENDANT;
  } else {
    throw new Error('Could not parse the selector expression.');
  }

  return {
    type: type,
    origin: origin,
    combinator: combinator,
    target: target
  };
}

function createElementLiteral(value) {
  return {
    type: ELEMENT_LITERAL,
    value: value
  };
}

function createCombinatorLiteral(value) {
  return {
    type: COMBINATOR_LITERAL,
    value: value
  };
}

/*
Types:
  SelectorSequence (root: RootElementLiteral, selectors: Array<SelectorExpression>) // root
  SelectorExpression (origin: ElementLiteral, combinator: CombinatorLiteral, target: ElementLiteral)
  ElementLiteral (value: String)
  CombinatorLiteral (value: String)
*/

var POS_NEXT_COMBINATOR = 1;
var POS_NEXT_ELEM = 2;
var POS_AFTER_NEXT_ELEM = 3;

function parser(tokens) {
  var initial = 0;
  var cursor = initial;

  if (tokens[initial] && tokens[initial].type !== ELEMENT_TOKEN) {
    throw new Error('Invalid token - expected selector sequence to start with an element. Instead was given:', tokens[cursor]);
  }
  var ast = createSelectorSequence([createSelectorExpression(undefined, undefined, tokens[initial])]);

  function walk() {
    var origin = tokens[cursor];
    var combinator = tokens[cursor + POS_NEXT_COMBINATOR];
    var target = tokens[cursor + POS_NEXT_ELEM];

    if (origin && origin.type === ELEMENT_TOKEN && combinator && combinator.type === COMBINATOR_TOKEN && target && target.type === ELEMENT_TOKEN) {
      cursor += tokens.length === cursor + POS_AFTER_NEXT_ELEM ? POS_AFTER_NEXT_ELEM : POS_NEXT_ELEM;
      return createSelectorExpression(createElementLiteral(origin.value), createCombinatorLiteral(combinator.value), createElementLiteral(target.value));
    } else {
      throw new Error('Syntax Error: Unexpected selector \'' + origin.value + ' ' + combinator.value + ' ' + target.value + '\'');
    }
  }

  while (cursor < tokens.length) {
    ast.selectors.push(walk());
  }

  return ast;
}

exports.default = parser;